<template>
  <b-modal
    id="modal-multi-3"
    v-model="$store.state.someVariables.showDocumentos"
    size="sm"
    title="DOCUMENTOS"
    ok-only
    ok-title="Accept"
  >
    <div class="document-list">
      <div
        v-for="(item, index) in listDocumentos"
        :key="item.id_archivo"
        class="document-item"
      >
        <button
          type="button"
          class="document-item__content"
          @click="openVocalia(item)"
        >
          <span class="document-item__index">{{ index + 1 }}</span>
          <span class="document-item__details">
            <span class="document-item__name">{{ item.name }}</span>
            <span class="document-item__date">{{ item.fecha }}</span>
          </span>
        </button>
        <button
          v-if="
            USER().rol === `${ROLES.ADMIN}` ||
              USER().rol === `${ROLES.SUPER}` ||
              USER().rol === `${ROLES.CALIFICACION}` ||
              (USER().rol === `${ROLES.CLUB}` && item.aprobado === 'n')
          "
          type="button"
          class="document-item__delete"
          title="Eliminar documento"
          aria-label="Eliminar documento"
          @click="removeDocument(item)"
        >
          <feather-icon icon="Trash2Icon" size="16" />
        </button>
        <label class="document-item__approval" :title="'Aprobar documento'">
          <input
            :disabled="
              USER().rol === `${ROLES.ADMIN}` ||
              USER().rol === `${ROLES.SUPER}` ||
              USER().rol === `${ROLES.CALIFICACION}`
                ? false
                : true
            "
            type="checkbox"
            :checked="item.aprobado === 's'"
            :aria-label="`Aprobar ${item.name}`"
            @change="updateEstadoArchivo(item, $event)"
          />
        </label>
      </div>
    </div>
    <template #modal-footer>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        class="float-right mr-1"
        @click="close"
      >
        Cerrar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  // BCardText,
  BButton,
  // BSpinner,
  // xxx,
  // xxxx,
  // sss,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import {
  URL,
  URL_PDF,
  USER,
  ROLES,
  //   ESTADO_JUGADOR,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'

export default {
  components: {
    BModal,
    // BCardText,
    BButton,
  },
  directives: {
    // 'b-popover': VBPopover,
    // heightFade,
    Ripple,
  },
  props: {
    listDocumentos: Array,
    playerSelected: Object,
  },
  setup(props) {
    const { postApi } = apiCall()

    function close() {
      store.commit('someVariables/UPDATE_SHOW_DOCUMENTOS', false)
    }
    function openVocalia(item) {
      console.log('item', item)
      window.open(
        `${URL_PDF}documentos/${item.path}?v=${Math.random() * 100}`,
        // eslint-disable-next-line
        '_blank',
      )
    }
    async function removeDocument(item) {
      const path = 'ApiInscripciones/deleteArchivoJugador'
      const data = {
        id_archivo: item.id_archivo,
        path: item.path,
        id_usuario: USER().id_usuario,
        id_torneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        movimiento: `Elimina documento ${item.name} del jugador con C.I ${props.playerSelected.ci_pasaporte}`,
      }
      const response = await postApi(URL, path, data)
      if (response && response.flag === 'si') {
        const index = props.listDocumentos.findIndex(
          document => document.id_archivo === item.id_archivo,
        )
        if (index !== -1) props.listDocumentos.splice(index, 1)
      }
    }
    async function updateEstadoArchivo(item, event) {
      const estadoAnterior = item.aprobado
      const aprobado = event.target.checked ? 's' : 'n'
      item.aprobado = aprobado

      const path = 'ApiInscripciones/updateEstadoArchivo'
      const data = {
        id_archivo: item.id_archivo,
        aprobado,
      }
      const response = await postApi(URL, path, data)
      if (!response || response.flag !== 'si') {
        item.aprobado = estadoAnterior
      }
    }
    return {
      close,
      openVocalia,
      removeDocument,
      updateEstadoArchivo,
      USER,
      ROLES,
    }
  },
}
</script>

<style scoped>
.document-list {
  display: grid;
  gap: 8px;
  padding: 4px 0;
}

.document-item {
  display: flex;
  align-items: center;
  min-width: 0;
  border: 1px solid #e6e8eb;
  border-radius: 6px;
  background: #fff;
}

.document-item__content {
  display: flex;
  flex: 1;
  align-items: center;
  min-width: 0;
  padding: 10px 8px;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.document-item__index {
  display: grid;
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  margin-right: 10px;
  place-items: center;
  border-radius: 50%;
  background: #f1f3f5;
  color: #495057;
  font-size: 12px;
  font-weight: 600;
}

.document-item__details {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.document-item__name {
  overflow: hidden;
  font-size: 13px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.document-item__date {
  color: #6c757d;
  font-size: 11px;
}

.document-item__delete {
  display: grid;
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  margin-right: 6px;
  place-items: center;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #c0392b;
  cursor: pointer;
}

.document-item__delete:hover {
  background: #fff0ee;
}

.document-item__approval {
  display: grid;
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  margin: 0 8px 0 0;
  place-items: center;
  cursor: pointer;
}

.document-item__approval input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: #28a745;
  cursor: pointer;
}
</style>
